import { ReactComponent as CloseX } from "@material-design-icons/svg/outlined/close.svg";

export default CloseX;
